import React, { memo, useMemo, lazy, Suspense, useState, useEffect } from 'react'
import { Loading } from 'components/shared'
import { useSelector } from 'react-redux'
import {
	LAYOUT_TYPE_CLASSIC,
	LAYOUT_TYPE_MODERN,
	LAYOUT_TYPE_SIMPLE,
	LAYOUT_TYPE_STACKED_SIDE,
	LAYOUT_TYPE_DECKED,
	LAYOUT_TYPE_BLANK
} from 'constants/theme.constant'
import useAuth from 'utils/hooks/useAuth'
import useDirection from 'utils/hooks/useDirection'
import useLocale from 'utils/hooks/useLocale'
import { publicRoutes, protectedRoutes } from 'configs/routes.config'
import authRoute from 'configs/routes.config/authRoute'
import { useNavigate, matchPath } from 'react-router-dom'



const layouts = {
	[LAYOUT_TYPE_CLASSIC]: lazy(() => {
		return import("./ClassicLayout");
	}),

	[LAYOUT_TYPE_MODERN]: lazy(() => {
		return import("./ModernLayout");
	}),

	[LAYOUT_TYPE_STACKED_SIDE]: lazy(() => {
		return import("./StackedSideLayout");
	}),

	[LAYOUT_TYPE_SIMPLE]: lazy(() => {
		return import("./SimpleLayout");
	}),

	[LAYOUT_TYPE_DECKED]: lazy(() => {
		return import("./DeckedLayout");
	}),

	[LAYOUT_TYPE_BLANK]: lazy(() => {
		return import("./BlankLayout");
	}),
};


const Layout = () => {
	let layoutType = useSelector((state) => state.theme.layout.type);
	// const userRoles = useSelector((state) => {
	// 	return state.profile.profile.userRoles
	// });
	const userRoles = (JSON.parse(localStorage.getItem("userDetails")))?.userRoles;
	const [layoutTyped, setLayoutType] = useState(layoutType);

	const navigate = useNavigate();

	useEffect(() => {
		if (userRoles?.[0] === 'Company Admin') {
			setLayoutType('stackedSide')
		}
		else if (layoutType == "BLANK") {
			setLayoutType("modern")
		}
		else {
			setLayoutType(layoutType)
		}

	}, [userRoles, layoutType])

	const { authenticated } = useAuth();

	useDirection()

	useLocale()

	const AppLayout = useMemo(() => {
		const role = JSON.parse(localStorage.getItem("userDetails"))?.userRoles[0]
		const urlPath = window.location.pathname
		if ((urlPath === "/" || urlPath === "/Golf-Courses" || urlPath?.includes("/TeeTimeBooking")) && role !== "player" && role) {
			navigate('/home')
		}
		if (authRoute?.find((item) => {
			return matchPath(item.path, urlPath)
		})) {
			return lazy(() => import('./AuthLayout'))
		}

		const allRoutes = [...publicRoutes, ...protectedRoutes, ...authRoute]
		const isKnownRoute = allRoutes.some(route => {
			let path = route.path
			if (typeof path === 'string' && path !== '*' && !path.startsWith('/')) {
				path = '/' + path
			}
			return matchPath(path, urlPath)
		})

		if (!isKnownRoute && urlPath !== '/') {
			return layouts[LAYOUT_TYPE_BLANK]
		}

		return layouts[layoutTyped]
	}, [layoutTyped, authenticated, window.location.pathname])

	const [renderKey, setRenderKey] = useState(0)

	useEffect(() => {
		const handler = () => {
			setRenderKey(prev => prev + 1);
		};


		window.addEventListener('auth-change', handler);
		return () => window.removeEventListener('auth-change', handler);
	}, []);

	return (
		<Suspense
			fallback={
				<div className="flex flex-auto flex-col h-[100vh]">
					<Loading loading={true} />
				</div>
			}
		>
			<AppLayout key={renderKey} />
		</Suspense>
	)
}

export default memo(Layout)